/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      route — bootstraps the guide personal-data wizard: reloads
 *              session `me`, loads the open organization, then triggers the
 *              controller's data load
 *   extends:   Route
 *   template:  none
 *   model:     model() performs requestMeTask (fire-and-forget) and returns
 *              nothing itself
 *   key:       beforeModel (session bootstrap), model, setupController
 *              (perform loadDataTask), resetController (cancelAll
 *              loadDataTask), requestMeTask
 *   uses:      intl/store/session services
 *   siblings:  controllers/guide-personal-data.js,
 *              templates/guide-personal-data.hbs, routes/heliguides-sign-request.js
 *              (re-exports this file's default class)
 *   tests:     route-hooks-test.js, module-contracts-test.js
 *
 * Also serves the heliguides-sign-request URL via a plain re-export (see
 * routes/heliguides-sign-request.js) — both flows share the same session/
 * open-organization bootstrap.
 */
import Route from '@ember/routing/route';

import { set } from '@ember/object';
import { task, timeout } from 'ember-concurrency';

import { service } from '@ember/service';

export default class GuidePersonalDataRoute extends Route {
  @service intl;
  @service store;
  @service session;

  async beforeModel(transition) {
    const controller = this.controllerFor('application');
    this.session.setAnonymous(true);
    await this.session.bootstrapSession(transition, controller);
  }

  model(params) {
    this.requestMeTask.perform();
  }

  setupController(controller, model) {
    controller.loadDataTask.perform();
  }

  resetController(controller) {
    controller.loadDataTask.cancelAll();
  }

  @task({ restartable: true }) *requestMeTask(/*transition*/) {
    yield timeout(250);

    var controller = this.controllerFor('application');

    try {
      yield this.session.reloadMeTask.perform();
    } catch (e) {
      set(controller, 'PHCustomData', null);
      return false;
    }

    const me = this.session.me;

    localStorage.removeItem('_beebeeScreenSaver');

    var organizationName = me.get('organization.name') ? me.get('organization.name') + ' - ' : '';
    document.title = organizationName + 'Beebeeboard';

    yield this.session.loadOpenTask.perform(true);

    set(controller, 'gdprField', this.session.gdprField);
    set(controller, 'content.me', me);
    set(controller, 'content.open_organization', this.session.openOrganization);
  }
}
